<template>
  <div
    :class="{
      'w-read-only-text-field--error': errorMessages.length > 0,
      'w-read-only-text-field--align-right': alignRight,
      'w-read-only-text-field--next-to-each-other': nextToEachOther,
      'w-read-only-text-field--space-between': spaceBetween,
    }"
    @click="$emit('click', $event)"
  >
    <div
      v-if="label && inlineReadOnly"
    >
      <h5 class="d-inline-flex">
        {{ label }}:
      </h5>
      <label
        v-if="hasHtml"
        v-html="cleanHtml(valueWithSuffix)"
      />
      <label v-else>
        {{ valueWithSuffix }}
      </label>
    </div>
    <div
      v-else-if="label && !inlineReadOnly"
      class="w-read-only-text-field"
    >
      <h5
        v-if="label"
        class="w-h5"
      >
        {{ label }}
      </h5>
      <v-skeleton-loader
        v-if="pending"
        class="mt-2"
        style="width: 50%"
        type="text"
      />

      <slot
        v-else
        name="valueLabel"
        :value-label="valueLabel"
      >
        <label
          v-if="hasHtml"
          v-html="cleanHtml(valueLabel)"
        />
        <label v-else>
          {{ valueLabel }}
        </label>
      </slot>
    </div>
    <label
      v-else-if="hasHtml"
      class="w-read-only-text-field__label"
      v-html="cleanHtml(valueWithSuffix)"
    />
    <label
      v-else
      :class="isMobileMaintenance ? 'w-read-only-text-field__label mobile-maintenance' : 'w-read-only-text-field__label'"
    >
      {{ valueWithSuffix }}
    </label>
    <label
      v-if="errorMessages.length > 0"
      class="v-messages error--text"
    >
      {{ errorMessages.join(',') }}
    </label>
  </div>
</template>

<script>
import DOMPurify from 'dompurify';

export default {
  props: {
    prefix: String,
    suffix: String,
    label: String,
    value: null,
    inlineReadOnly: { type: Boolean, default: false },
    errorMessages: { type: Array, default: () => [] },
    alignRight: { type: Boolean, default: false },
    pending: { type: Boolean, default: false },
    nextToEachOther: { type: Boolean, default: false },
    hasHtml: { type: Boolean, default: false },
    spaceBetween: { type: Boolean, default: false },
    isMobileMaintenance: { type: Boolean, default: false }
  },
  methods: {
    cleanHtml(dirtyHtml) {
      return DOMPurify.sanitize(dirtyHtml, { USE_PROFILES: { html: true } });
    }
  },
  computed: {
    internalValue() {
      return this.value !== undefined && this.value !== null ? this.value : '-';
    },
    valueLabel() {
      return `${this.prefix || ''}${this.internalValue}${this.suffix ? ' ' + this.suffix : ''}`;
    },
    valueWithSuffix() {
      return `${this.internalValue}${this.suffix ? ' ' + this.suffix : ''}`;
    }
  },
};
</script>

<style scoped lang="scss">
@import '~vuetify/src/styles/styles';

.w-read-only-text-field {
  min-height: 2.75rem;

  & > label {
    @include w-p1;
    color: $input-read-only-color;
    word-break: break-word;
    white-space: pre-line;
  }

  &--error label,
  &--error h5 {
    color: var(--v-error-base);
  }

  &--align-right {
    text-align: right;
  }

  &--next-to-each-other .w-read-only-text-field {
    display: flex;
    align-items: center;

    .w-h5 {
      margin-right: $grid-gutter;
    }
  }
  &--space-between .w-read-only-text-field{
    justify-content: space-between;
  }
}

.w-read-only-text-field__label {
  @include w-p1;
  word-break: break-word;
  white-space: pre-line;
}

.mobile-maintenance {
  font-size: .65rem !important;
}
</style>
